<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import { is_set_object } from '$lib/js/helpers';
  import { t } from 'svelte-i18n-lingui';
  import type { VerticalTabsComponent } from "$lib/js/strapi/types";

  export let component: VerticalTabsComponent
  export let type: 'default' | 'white' | 'grey' = 'default'

  let selected = 'panel0'
  let expanded = false
  let tabs = component.tabs
</script>


<div class="vertical-tabs__container">
  <div class="vertical-tabs {type}">
    <div class="vertical-tabs__tabs">
      {#each tabs as tab, index}
        <button
          class="vertical-tabs__tab lead-1"
          class:selected={selected === `panel${index}`}
          on:click={() => selected = `panel${index}`}
        >
          {tab.title}
        </button>
      {/each}
    </div>

    <div class="panels">
      {#each tabs as tab, index}
        <div class="panel lead-2" class:selected={selected === `panel${index}`} class:expanded={expanded === true}>
          <div class="panel__wrapper">
            <div class="panel__inner">
              {#if is_set_object(tab.image)}
                <div class="panel--left">
                  <Lazy height={200}>
                    <img title="Bixoto Team" src="{PUBLIC_STRAPI_MEDIA}{tab.image?.url}" alt="Nuestra vision icono">
                  </Lazy>
                </div>
              {/if}

              <div class="panel--right">
                <p>{@html tab.content}</p>
              </div>
            </div>
          </div>
          <button class="expand" on:click={() => expanded = !expanded}>
            {#if expanded === true}
              {$t`View less`}
            {:else}
              {$t`View more`}
            {/if}
          </button>
        </div>
      {/each}
    </div>
  </div>
</div>


<style lang="scss">
  .vertical-tabs {
    display: flex;
    padding: 20px 0;

    @media (max-width: 768px) {
      flex-direction: column;
      padding: 20px 0 50px;
    }

    &__container {
      overflow: auto;
    }

    &__title {
      margin-top: 80px;
      font-weight: 700;
      color: var(--main);
    }

    &__tabs {
      display: flex;
      flex-direction: column;

      @media (max-width: 768px) {
        padding-right: 10px;
        background: #fff5f2;
      }
    }

    &__tab {
      cursor: pointer;
      padding: 10px 20px;
      margin: 0px 2px;
      background: #ffe3d9;
      display: flex;
      align-items: center;
      font-weight: 700;
      line-height: 1.2;
      min-height: 40px;
      color: #ff5501;
      flex: 1 1 100%;
      text-align: left;

      @media (min-width: 769px) {
        padding: 15px 30px;
        min-width: 260px;
        min-height: 70px;
      }

      &.selected {
        background: #fff5f2;
        color: var(--main);
        border-left: 4px solid #ff5501;
        font-weight: 900;
      }
    }

    .panels {
      background: #fff5f2;
      min-height: 200px;
      overflow: hidden;
      padding: 20px;
      margin-left: -2px;

      @media (min-width: 481px) {
        padding: 30px;
      }
    }

    .panel {
      display: none;

      &.selected {
        display: block;
      }

      &.expanded {
        .panel {
          &__wrapper {
            max-height: 100%;
          }
        }
      }

      .expand {
        margin-top: 20px;
        padding: 5px 10px;
        width: 100%;
        border: 1px solid black;
        border-radius: 5px;

        @media (min-width: 481px) {
          display: none;
        }
      }

      &__wrapper {
        position: relative;

        @media (max-width: 480px) {
          max-height: 200px;
          overflow: hidden;

          &::before {
            content: "";
            position: absolute;
            bottom: 0;
            z-index: 0;
            height: 50px;
            width: 100%;
            background: linear-gradient(rgba(240,240,240,0), rgba(240,240,240,1));
          }
        }
      }

      &__inner {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;

        @media (max-width: 480px) {
          flex-direction: column-reverse;
        }

        .panel--right {
          @media (min-width: 481px) {
            width: calc(100% - 230px);
          }
        }
      }

      img {
        width: 100%;
        max-width: 200px;

        @media (max-width: 480px) {
          margin: 20px;
        }
      }
    }

    &.white {
      .vertical-tabs {
        &__tabs {
          background: white;
        }

        &__tab {
          background-color: rgba(255, 66, 0, 0.05);

          &.selected {
            background: white;
          }
        }
      }

      .panels {
        background-color: white;
      }
    }

    &.grey {
      .vertical-tabs {
        &__tabs {
          background: var(--grey);
        }

        &__tab {
          background-color: #D0D0D0;
          color: #646464;

          &.selected {
            background: var(--grey);
            color: black;
            border-color: black;
          }
        }
      }

      .panels {
        background-color: var(--grey);
      }
    }
  }
</style>
